import React from "react";
import { useWindowDimensions, View } from "react-native";
import Colors from "../../styles/colors";
import StandardText from "../standardText/StandardText";
import PlayerBadge from "../../game/components/PlayerBadge";

const dateFormatter = new Intl.DateTimeFormat('en-US', { dateStyle: 'short', timeStyle: 'short' });
const formatDate = (date) => dateFormatter.format(new Date(date));

export function UserMessage({ sender, content, createdAt, isSender, firstInChain }) {
    const { width, height } = useWindowDimensions();
    const chatWidth = width < 400 ? "100%" : (width < 512 ? 320 : (width < 1368 ? 416 : 768));

    return (
        <View style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: isSender ? "flex-end" : "flex-start",
            marginTop: 8,
        }}>
            {!isSender && firstInChain && (<PlayerBadge player={{userAccount: sender}} showBottomInfo={false} bare={true} popupEnabled={false} animate={false} enablePresenceIndicator={false} />)}
            <View style={{
                display: "flex",
                flexDirection: "column",
                backgroundColor: isSender ? Colors.primary5 : Colors.background3,
                marginTop: 4,
                marginLeft: isSender ? 0 : (firstInChain ? 4 : 40),
                marginRight: !isSender ? 0 : 4,
                padding: 8,
                borderRadius: 8,
                borderTopLeftRadius: isSender ? 8 : 0,
                borderTopRightRadius: isSender ? 0 : 8,

                maxWidth: chatWidth,
            }}>
                {firstInChain && !isSender && (
                    <View style={{ flexDirection: 'row' }}>
                        <StandardText style={{ fontSize: 12, fontWeight: "bold", color: Colors.onBackground }}>
                            {sender.user?.firstName}
                        </StandardText>
                    </View>
                )}
                <StandardText style={{ fontSize: 16, fontWeight: "bold", color: Colors.onBackground }}>
                    {content}
                </StandardText>
                <StandardText Text style={{ color: Colors.onBackground3, fontSize: 12 }}>
                    {formatDate(createdAt)}
                </StandardText>
            </View>
            {/* {isSender && firstInChain && (<PlayerBadge player={{userAccount: sender}} showBottomInfo={false} bare={true} popupEnabled={false} animate={false} />)} */}
        </View>
    );
}